import { atom, useAtomValue } from "jotai";

import type { BillingStateQuery } from "~/graphql/graphql-new.gen";
import { useBillingStateQuery } from "~/graphql/graphql-new.gen";
import { activeSaleIdState } from "~/stores/sales";

import { applyBillingStatePreview, getBillingPreview } from "./billing-preview";

export const billingStateState = atom<
  BillingStateQuery["supplierBillingState"] | undefined
>(undefined);

export const useBillingState = () => {
  const activeSaleId = useAtomValue(activeSaleIdState);
  const preview = getBillingPreview();

  const billingState = useBillingStateQuery(
    {
      saleId: activeSaleId ?? "",
    },
    {
      enabled: !!activeSaleId,
      refetchOnWindowFocus: false,
      select: (data) =>
        applyBillingStatePreview(data.supplierBillingState, preview),
      staleTime: 1000,
    },
  );

  return billingState;
};
